import cookie from 'vue-cookies';
import dayjs from 'dayjs';
import * as types from '../mutation-types';
import { getUserByRole } from '../../assets/api/user';
import { getOnlineList, getOnlineNum } from '../../assets/api/loginWatch';

const cookieValue = cookie.get('CWLUser');
const cookieShowNoticeboard = cookie.get('isShowNoticeboard');

// State object
const state = () => ({
  loading: 0,
  user: {
    name: cookieValue ? cookieValue.name : '',
    id: cookieValue ? cookieValue.id : '',
    token: cookieValue ? cookieValue.token : '',
  },
  isShowNoticeboard: !!(cookieShowNoticeboard === null || cookieShowNoticeboard === 'true'),
  isShowModal: false,
  modalName: '',
  teacherList: [],
  studentList: [],
  isCommitment: null,
  onlineData: {
    number: 0,
    list: null,
  },
});

// Getter functions
const getters = {};

// Actions
const actions = {
  async getTeacherList({ commit }) {
    try {
      const { data } = await getUserByRole('teacher');
      commit(types.SET_TEACHER_LIST, data);
    } catch {
      //
    } finally {
      //
    }
  },
  async getStudentList({ commit }) {
    try {
      const { data } = await getUserByRole('student');
      commit(types.SET_STUDENT_LIST, data);
    } catch {
      //
    } finally {
      //
    }
  },

  async getOnlineDataForSW({ commit }) {
    try {
      const { data } = await getOnlineNum(dayjs().format('YYYY-MM-DD HH:mm:ss'));
      commit(types.SET_ONLINE_DATA, data);
    } catch {
      //
    } finally {
      //
    }
  },

  async getOnlineData({ commit }) {
    try {
      const { data } = await getOnlineList(dayjs().format('YYYY-MM-DD HH:mm:ss'));
      commit(types.SET_ONLINE_DATA, data);
    } catch {
      //
    } finally {
      //
    }
  },
};

// Mutations
const mutations = {
  [types.SET_USER_INFO](state, payload) {
    const { token, id, name } = payload;
    state.user.token = token;
    state.user.id = id;
    state.user.name = name;
  },
  [types.START_LOADING](state) {
    state.loading += 1;
  },
  [types.FINISH_LOADING](state) {
    state.loading -= 1;
  },
  [types.SET_MODAL_STATUS](state, isShow) {
    state.isShowModal = isShow;
  },
  [types.SET_MODAL_NAME](state, name) {
    state.modalName = name;
  },
  [types.SET_TEACHER_LIST](state, list) {
    state.teacherList = list;
  },
  [types.SET_STUDENT_LIST](state, list) {
    state.studentList = list;
  },
  [types.SET_COMMITMENT_STATUS](state, status) {
    state.isCommitment = status;
  },
  [types.SET_NOTICEBOARD_STATUS](state, status) {
    state.isShowNoticeboard = status;
  },
  [types.SET_ONLINE_DATA](state, res) {
    state.onlineData.number = res.login_count;
    state.onlineData.list = res.login_records;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
